/**
 * Icon + accent color per coarse file kind (see getFileKind in
 * documentConstants). Shared by DocumentsPanel rows, the viewer modal,
 * and the fallback card so a PDF looks like the same PDF everywhere.
 */
import { FiFile, FiFileText, FiImage, FiGrid } from 'react-icons/fi';

export const FILE_KIND_STYLES = {
  pdf: { icon: FiFileText, color: 'red.500' },
  word: { icon: FiFileText, color: 'blue.500' },
  excel: { icon: FiGrid, color: 'green.500' },
  powerpoint: { icon: FiFile, color: 'orange.500' },
  image: { icon: FiImage, color: 'purple.500' },
  text: { icon: FiFileText, color: 'gray.500' },
  other: { icon: FiFile, color: 'gray.500' },
};

export function getFileKindStyle(kind) {
  return FILE_KIND_STYLES[kind] || FILE_KIND_STYLES.other;
}
